import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import WorkStatusTab from "./tabs/WorkStatusTab";

const BranchWorkStatusPage = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();

  return (
    <section className="admin-page">
      <header className="detail-header">
        <button className="back-btn" type="button" onClick={() => navigate('/admin/branches')}>
          ←
        </button>
        <h2 className="section-title">근무현황</h2>
      </header>

      {branchId && <WorkStatusTab branchId={Number(branchId)} />}
    </section>
  );
};

export default BranchWorkStatusPage;
